<template>
    <header class="site-header">
        <div class="container">
            <div class="row">
                <div class="col align-self-end">
                    <ul class="social-icon">
                        <li class="social-icon-item">
                            <a href="https://wa.me/17542761746" target="_blank" class="social-icon-link bi-whatsapp">
                            </a>
                        </li>
                        <li class="social-icon-item">
                            <a 
                                href="https://diversecarenow.as.me/schedule/6a240cde"
                                target="_blank"
                                class="social-icon-link bi bi-calendar-event">
                            </a>
                        </li>
                        <li class="social-icon-item">
                            <a 
                                href="https://www.instagram.com/diversecarenow/?igshid=YmMyMTA2M2Y%3D"
                                target="_blank"
                                class="social-icon-link bi-instagram">
                            </a>
                        </li>
                        <li class="social-icon-item dropdown" style="margin-left:20px;">
                            <a class="nav-link dropdown-toggle p-0" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <span :class="currentLanguage.flag" class="flag-icon-header"></span>
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                                <li v-for="lang in languages" :key="lang.code">
                                    <a class="dropdown-item" href="#" @click.prevent="setLocale(lang)">
                                        <span :class="lang.flag" class="flag-icon-dropdown"></span> {{ lang.name }}
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </header>
</template>
<script>
    import 'flag-icons/css/flag-icons.min.css';
    import { useI18n } from 'vue-i18n';
    import { ref, computed } from 'vue';
    import { LANGUAGES } from './../common/constants';

    export default({
        setup() {
            const { locale } = useI18n({ useScope: 'global' });

            const languages = ref([
                { code: LANGUAGES.EN, name: 'English', flag: 'fi fi-us' },
                { code: LANGUAGES.PT_BR, name: 'Português', flag: 'fi fi-br' },
                { code: LANGUAGES.ES, name: 'Español', flag: 'fi fi-cu' }
            ]);

            const currentLanguage = computed(() => {
                return languages.value.find(lang => lang.code === locale.value) || languages.value[0];
            });

            const setLocale = (lang) => {
                if (lang && lang.code) {
                    locale.value = lang.code;
                }
            }

            // Set initial locale if not set
            if (!locale.value) {
                locale.value = LANGUAGES.EN;
            }

            return {
                setLocale,
                locale,
                languages,
                currentLanguage
            }
        }
    })
</script>

<style>
.flag-icon-header {
    font-size: 32px;
    line-height: 32px;
}

.flag-icon-dropdown {
    font-size: 24px;
    line-height: 24px;
    margin-right: 10px;
}
</style>